module.exports = __webpack_public_path__ + "img/shangin.bb7ec56a.png";